import { api } from '../../services/api'

export const updateFacilityPlaygroups = (facilityId, playgroups) => {
	return api
		.patch(`/facilities/${facilityId}`, { playgroups })
		.then((response) => {
			return response.data
		})
		.catch((e) => {
			console.log(e)

			return null
		})
}

export const setSelectedPlaygroupsFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_PLAYGROUPS_FILTERS', payload: filters })
	}
}
